<div class="search-field">
    <div class="title-container">
        <span class="title">Filters</span>
        <button type="button" class="plus-btn" (click)="addFormControl()" aria-label="Add filter">
            <i class="bi bi-plus-square"></i>
        </button>
    </div>

    <form [formGroup]="searchFilterForm" class="form-group" (ngSubmit)="onSubmit()">
        <ng-container *ngFor="let group of searchFilterForm.controls | keyvalue">
            <div [formGroupName]="group.key" class="f-search">
                <mat-form-field>
                    <mat-select formControlName="option">
                        <mat-option *ngFor="let option of allAvailableOptions" [value]="option">
                            {{ formatEnumKey(option) }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="custom-mat-input">
                    <input matInput type="text" formControlName="value" />
                </mat-form-field>
                <button type="button" (click)="deleteSearchBar(group.key)" class="delete-btn" aria-label="Remove filter">
                    <i class="bi bi-x-square"></i>
                </button>
            </div>
        </ng-container>

        <div class="bs-area">
            <div class="buttons-position">
                <button type="submit" class="custom-btn" [disabled]="!hasFormControls() || searchFilterForm.invalid">Search</button>
                <button type="button" class="close-btn" (click)="clearFilters()">Clear filters</button>
            </div>
            <div class="close-button">
                <button type="button" class="close-btn" (click)="closeModal()">Close</button>
            </div>
        </div>
    </form>
</div>
